import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import {
  updateAboutUsParagraph,
  getAboutUsParagraph,
  createAboutUsParagraph,
} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

// Validation Schema
const validationSchema = Yup.object({
  paragraph: Yup.string()
    .required("Paragraph is required"),
});

export default function ParagraphEdit() {
  const {id, partnerId } = useParams();

  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
  const [paragraph, setParagraph] = useState({
    paragraph: "",
    index: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  const getInitialValues = () => ({
    paragraph: paragraph.paragraph || "",
  });

  const fetchParagraphData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await getAboutUsParagraph(id);
      const paraData = response.data.data[0];
      setParagraph({
        ...paraData,
        index: response.data.data.indexOf(paraData),
      });
      console.log(response.data.data[0].paragraph);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to fetch paragraph data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParagraphData();
  }, [id]);

  const createTitle = async (formData) => {
    setIsUpdating(true);
    try {
      const response = await createAboutUsParagraph(formData);
      if(response.status === 200){
        showToast({
          type: 'success',
          message: response?.data?.message || "Paragraph section has been created successfully!",
        });
        const headerData = response?.data?.data;
        setParagraph(headerData);
        if (headerData && headerData.id) {
          navigate(`/${partnerId}/aboutus/paragraph/edit/${headerData.id}`);
        }
      }else{
        showToast({
          type: 'error',
          message: response?.data?.message || "Failed to create paragraph section. Please try again.",
        });
      }
      console.log(response.data);
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to create paragraph section. Please try again.",
      });
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const updateTitle = async (id, formData) => {
    setIsUpdating(true);
    try {
      const response = await updateAboutUsParagraph(id, formData);
      console.log(response.data);
      showToast({
        type: 'success',
        message: response?.data?.message || "Paragraph section has been updated successfully!",
      });
      setParagraph(response.data.data);
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to update paragraph section. Please try again.",
      });
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleSubmit = async (values) => {
    const formData = {
      paragraph: values.paragraph, 
    };
    
    if (!Number(id)){
      formData.partner_id = partnerId;
      await createTitle(formData);
    } else {
      await updateTitle(id, formData);
    }
  };

  return (
    <>
     {isLoading ? <CmsCircularProgress/> : 
     <FormWrapper>
      <Title>{Number(id) ? 'Edit' : 'Add' } Paragraph section</Title>
      <SliderDiv>
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            getFieldProps,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <FormGroup 
                label="Enter a New Paragraph" 
                requiredField
                error={touched.paragraph && errors.paragraph ? errors.paragraph : ''}
              >
                <Form.Control
                  as="textarea"
                  rows={4}
                  {...getFieldProps('paragraph')}
                  placeholder="Enter paragraph content here..."
                  isInvalid={touched.paragraph && !!errors.paragraph}
                />
              </FormGroup>
              
              <ButtonWrapper className="mt-3">
                <Link
                  to={`/${partnerId}/aboutus/paragraph/view/${Number(id) ? id : 'create'}`}
                  style={{
                    width: "50%",
                  }}
                >
                  <Button variant="secondary">Go Back</Button>
                </Link>
                <Button
                  type="submit"
                  style={{
                    width: "50%",
                  }}
                  disabled={isUpdating || isSubmitting}
                >
                  {isUpdating ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </SliderDiv>
    </FormWrapper>}
    </>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 2rem;
    @media (max-width: 890px) {
  gap: 2rem;
}
 @media (max-width: 425px) {
  gap: 1rem;
}
`;
